import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Button, ButtonToolbar, Schema } from "rsuite";
import { NotificationManager } from "react-notifications";
import axios from "axios";
import { API_URL } from "../../shared/constant";
import "rsuite/dist/rsuite.min.css";
const TextField = ({ name, label, accepter, ...rest }) => (
  <Form.Group controlId={name}>
    <Form.ControlLabel>{label} </Form.ControlLabel>
    <Form.Control name={name} accepter={accepter} {...rest} />
  </Form.Group>
);
const { StringType } = Schema.Types;
const model = Schema.Model({
  username: StringType().isRequired("This field is required."),
  password: StringType().isRequired("This field is required."),
});
const forgotPasswordModel = Schema.Model({
  email: StringType()
    .isEmail("Please enter a valid email address.")
    .isRequired("This field is required."),
});

const LoginForm = ({ onSubmit }) => {
  const [showForgotForm, setShowForgotForm] = useState(false);
  const [formValue, setFormValue] = useState({
    username: "",
    password: "",
  });

  const [forgotFormValue, setForgotFormValue] = useState({
    username: "",
    password: "",
  });

  const handleForgotSubmit = async (data) => {
    axios
      .post(API_URL.FORGOT_PASSWORD, {
        email: data.email,
      })
      .then((res) => {
        if (res.data.code === 200) {
          NotificationManager.success(res.data.msg, "Successful!", 2000);
          setForgotFormValue({
            email: "",
          });
        } else {
          NotificationManager.error(res.data.msg, "Error!");
        }
      })
      .catch((err) => {
        NotificationManager.error("Error while forgot password!", "Error!");
      });
  };

  return (
    <Fragment>
      <Form
        model={model}
        fluid
        onChange={setFormValue}
        formValue={formValue}
        onSubmit={() => onSubmit(formValue)}
        className={showForgotForm ? "d-none" : "d-block"}
      >
        <h3>Sign In</h3>

        <TextField name="username" label="Username" type="text" />
        <TextField name="password" label="Password" type="password" />
        <Form.Group className="text-right">
          <Link className="text-dark" onClick={() => setShowForgotForm(true)}>
            Forgot password?
          </Link>
        </Form.Group>
        <ButtonToolbar>
          <Button
            appearance="default"
            className="btn-thm w-100"
            type="submit"
            disabled={!formValue.username && !formValue.password}
          >
            Submit
          </Button>
        </ButtonToolbar>
      </Form>
      <Form
        model={forgotPasswordModel}
        fluid
        onChange={setForgotFormValue}
        formValue={forgotFormValue}
        onSubmit={() => handleForgotSubmit(forgotFormValue)}
        className={!showForgotForm ? "d-none" : "d-block"}
      >
        <h3>Forgot Password</h3>

        <TextField name="email" label="Email Address" type="email" />
        <Form.Group className="text-right">
          <Link className="text-dark" onClick={() => setShowForgotForm(false)}>
            Login here?
          </Link>
        </Form.Group>
        <ButtonToolbar>
          <Button
            appearance="default"
            className="btn-thm w-100"
            type="submit"
            disabled={!forgotFormValue.email}
          >
            Send Reset Code
          </Button>
        </ButtonToolbar>
      </Form>
    </Fragment>
  );
};

export default LoginForm;
